import React from "react";
import assetify from "@quintype/framework/assetify";
import PropTypes from "prop-types";
import { SUBSCRIPTION_PAGE_URL } from "../../../../isomorphic/constants";
import subscriptionImage from "../../../../assets/images/nl-images/subscription-CTA.png";
import { Button } from "../../atoms/button";

import "./subscription-cta.m.css";

const SubscriptionCTA = ({ url = "" }) => {
  return (
    <div styleName="wrapper">
      <div styleName="image-wrapper">
        <img styleName="image" src={assetify(subscriptionImage)} alt="newslaundry logo" />
      </div>
      <div styleName="content-wrapper">
        <h4 styleName="headline">Pay to keep news free </h4>
        <div styleName="content">
        Complaining about the media is easy and often justified. But hey, it’s the model that’s flawed.
        </div>
        <div styleName="button">
          <Button className="nl-btn-large" href={SUBSCRIPTION_PAGE_URL + `?story-url=/${url}`}>
            Subscribe
          </Button>
        </div>
      </div>
    </div>
  );
};

SubscriptionCTA.propTypes = {
  url: PropTypes.string
};

export { SubscriptionCTA };
